"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _moduleRegistry = _interopRequireDefault(require("./module-registry"));

var _baseLazyComponent = _interopRequireDefault(require("./base-lazy-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ReactLazyComponent = /*#__PURE__*/function (_BaseLazyComponent) {
  _inheritsLoose(ReactLazyComponent, _BaseLazyComponent);

  function ReactLazyComponent(props, manifest) {
    var _this;

    _this = _BaseLazyComponent.call(this, props, manifest) || this;
    _this.state = {
      component: null
    };
    return _this;
  }

  var _proto = ReactLazyComponent.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.resourceLoader.then(function () {
      var component = _moduleRegistry["default"].component(_this2.manifest.component);

      _this2.setState({
        component: component
      });
    });
  };

  _proto.render = function render() {
    return this.state.component ? /*#__PURE__*/_react["default"].createElement(this.state.component, this.mergedProps) : null;
  };

  return ReactLazyComponent;
}(_baseLazyComponent["default"]);

var _default = ReactLazyComponent;
exports["default"] = _default;